function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7045",
  "data-name": "Grupo 7045",
  transform: "translate(-320.639 -149.146)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7043",
  "data-name": "Grupo 7043"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7037",
  "data-name": "Grupo 7037"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_601",
  "data-name": "Caminho 601",
  d: "M330.4,163.119c-4.842,0-8.689-4.009-8.85-4.18l-.228-.24.228-.241c.161-.17,4.008-4.18,8.85-4.18s8.689,4.01,8.85,4.18l.228.241-.228.24C339.093,159.11,335.247,163.119,330.4,163.119Zm-8.1-4.42c.907.859,4.222,3.719,8.1,3.719s7.19-2.86,8.1-3.719c-.907-.859-4.222-3.72-8.1-3.72S323.214,157.84,322.307,158.7Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7038",
  "data-name": "Grupo 7038"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_602",
  "data-name": "Caminho 602",
  d: "M330.246,162.319a3.67,3.67,0,1,1,3.67-3.669A3.674,3.674,0,0,1,330.246,162.319Zm0-6.638a2.969,2.969,0,1,0,2.969,2.969A2.973,2.973,0,0,0,330.246,155.681Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7040",
  "data-name": "Grupo 7040"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7039",
  "data-name": "Grupo 7039"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_603",
  "data-name": "Caminho 603",
  d: "M330.074,156.577a2.153,2.153,0,0,0-.725.133.962.962,0,1,1-1.313,1.313,2.166,2.166,0,1,0,2.038-1.446Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7042",
  "data-name": "Grupo 7042"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7041",
  "data-name": "Grupo 7041"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_604",
  "data-name": "Caminho 604",
  d: "M321.113,157.592l-.474-.368a13.011,13.011,0,0,1,9.737-4.616,11.793,11.793,0,0,1,9.24,4.12l-.48.36a11.4,11.4,0,0,0-8.76-3.88A12.634,12.634,0,0,0,321.113,157.592Z"
})))));

function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.977,
    height: 16.707,
    viewBox: "0 0 18.977 16.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.71981a50.svg";
export { ForwardRef as ReactComponent };